import { gql } from '__generated__';

export const COMPLETE_ACTIVITY_ASSIGNMENT_MUTATION = gql(/* GraphQL */ `
  mutation completeActivityAssignment($input: CompleteActivityAssignmentInput!) {
    completeActivityAssignment(input: $input) {
      success
      error
    }
  }
`);
